import _ from "lodash";
import {
  EnumOperatorPricing,
  EnumOperatorType,
  EnumPeopleVisibleToSystemRoles,
  SeasonalityEnum,
} from "gql/generated";
import i18n from "i18next";
import { i18nNamespace, loadLanguagePacks } from "i18n.ts";
import { Months } from "shared/types";

await loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Adminland]);

export const businessTypeOptions = _.sortBy(
  Object.values(EnumOperatorType).map(val => {
    return {
      label: i18n.t(`core:LOOKUPS.OPERATOR_TYPE.${val}`),
      value: val,
    };
  }),
  "label",
);

// Explicitly state the enum options to maintain a certain order
export const seasonalityOptions = Object.values([
  SeasonalityEnum.High,
  SeasonalityEnum.Low,
  SeasonalityEnum.Closed,
])
  .map(val => {
    return {
      label: i18n.t(`core:LOOKUPS.SEASONALITY.${val}`),
      value: val as SeasonalityEnum,
    };
  })
  .filter(option => option.value && option.value.length > 0);

export const monthsShortOptions = Object.values(Months).map(val => {
  return {
    label: i18n.t(`core:LOOKUPS.MONTHS.${val}_SHORT`),
    value: val,
  };
});

export const pricingOptions = _.sortBy(
  Object.values(EnumOperatorPricing).map(val => {
    return {
      label: i18n.t(`core:LOOKUPS.OPERATOR_PRICING.${val}`),
      value: val,
    };
  }),
  "label",
);

// Order: 1 Whereabouts Users, 2 [Org] Staff, 3 Operators, 4 Customer, 5 Lead, 6 Event Creator
export const roleOrder = [
  EnumPeopleVisibleToSystemRoles.WhereaboutsUser,
  EnumPeopleVisibleToSystemRoles.DmoStaff,
  EnumPeopleVisibleToSystemRoles.Operator,
  EnumPeopleVisibleToSystemRoles.Customer,
  EnumPeopleVisibleToSystemRoles.Lead,
  EnumPeopleVisibleToSystemRoles.EventCreator,
];

export const ROLE_TAG_MAP: Record<
  EnumPeopleVisibleToSystemRoles,
  { visual: string; label: string }
> = {
  [EnumPeopleVisibleToSystemRoles.Customer]: {
    visual: "success",
    label: i18n.t("adminland:PAGE.PEOPLE.CUSTOMER"),
  },
  [EnumPeopleVisibleToSystemRoles.Operator]: {
    visual: "accent.blue",
    label: i18n.t("adminland:PAGE.PEOPLE.OPERATOR"),
  },
  [EnumPeopleVisibleToSystemRoles.DmoStaff]: {
    visual: "warning",
    label: i18n.t("adminland:PAGE.PEOPLE.DMOSTAFF"),
  },
  [EnumPeopleVisibleToSystemRoles.Lead]: {
    visual: "accent.magenta",
    label: i18n.t("adminland:PAGE.PEOPLE.LEAD"),
  },
  [EnumPeopleVisibleToSystemRoles.EventCreator]: {
    visual: "accent.purple",
    label: i18n.t("adminland:PAGE.PEOPLE.EVENT_CREATOR"),
  },
  [EnumPeopleVisibleToSystemRoles.WhereaboutsUser]: {
    visual: "accent.green",
    label: i18n.t("adminland:PAGE.PEOPLE.WHEREABOUTS_USERS"),
  },
};

export { TNB_INTERNAL_OWNER_ID } from "./internalIds";

export const IMPERSONATION_DEFAULTS = {
  DEV_PLAYGROUND_ADMIN: {
    userId: "69a1cc6ae845e2d3b2b30e4c",
    label: "Developer Playground Admin",
  },
  DEV_PLAYGROUND_OPERATOR: {
    userId: "69a1cccfe845e2d3b2b3125a",
    label: "Developer Playground Operator",
  },
  WHEREABOT: {
    userId: import.meta.env.VITE_WHEREABOT_USER_ID ?? "69b04ee3a0b3f1ba38fa9de6",
    label: "🤖 Whereabot",
  },
} as const;
